export default __webpack_public_path__ + "static/media/30.b25028e1.png";